import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RouteManager from 'Components/Route';
import { AppLayout } from 'Layouts';
import { HomeContainer } from 'Pages/Home/HomeContainer';
import { ResetGetEmailContainer } from 'Pages/ResetPassword/ResetGetEmailContainer';
import { ResetSignInContainer } from 'Pages/ResetPassword/ResetSignInContainer';
import { NotFoundContainer } from 'Pages/NotFound/NotFoundContainer';
import { SignInContainer } from 'Pages/SignIn/SignInContainer';
import { SignUpPlansContainer } from 'Pages/Plans/SignUpPlansContainer';
import { PaymentPage } from 'Pages/PaymentPage/PaymentPage';
import { CreateContainer } from 'Pages/CreateAccount/CreateContainer';
import { Confirmation } from 'Pages/Confirmation/Confirmation';
import { SignOutContainer } from 'Pages/SignOut/SignOutContainer';
import { CurrentSubscriberContainer } from 'Pages/CurrentSubscriber';
import { CurrentSubscriberMilitaryFirst } from 'Pages/CurrentSubscriberMilitaryFirst';
import { SupportedDevicesContainer } from 'Pages/SupportedDevices';
import { RedeemGiftHome } from 'Pages/RedeemGiftHome';
import { RedeemGiftCardContainer } from 'Pages/RedeemGiftCard/RedeemGiftCardContainer';
import { EditPaymentContainer } from 'Pages/EditPayment/EditPaymentContainer';
import { BillingHistoryContainer } from 'Pages/BillingHistory/BillingHistoryContainer';
import { CancelPlanContainer } from 'Pages/CancelPlan/CancelPlanContainer';
import { CancelSurveyContainer } from 'Pages/CancelPlan/CancelSurveyContainer';
import { CancelConfirmationContainer } from 'Pages/CancelPlan/CancelConfirmationContainer';
import { MyAccountContainer } from 'Pages/MyAccount/MyAccountContainer';
import { ShippingContainer } from 'Pages/Shipping/ShippingContainer';
import { PauseSubscriptionContainer } from 'Pages/PauseSubscription/PauseSubscriptionContainer';
import { MVPDContainer } from 'Pages/SignIn/MVPDContainer/MVPDContainer';
import { BangoFinal } from 'Pages/BangoFinal/BangoFinal';
import { SheerIdVerificationPage } from 'Pages/SheerIdVerification';
import { FeatureFlagsContainer } from 'Pages/FeatureFlags/FeatureFlagsContainer';
import { getDefaultConfig } from 'Utils/Store';
import { VeteransAdvantageError } from 'Pages/VeteransAdvantageError/VeteransAdvantageError';
import { FoxOneConfirmation } from 'Pages/FoxOneConfirmation/FoxOneConfirmation';

const { appEnv } = getDefaultConfig();

export const App = ({ routes }) => (
  <AppLayout>
    <Routes>
      {appEnv && appEnv !== 'production' && (
        <Route
          path={routes.welcome}
          element={<RouteManager title="Marketing Landing" eventName="home_landing" component={HomeContainer} />}
        />
      )}
      <Route
        path={routes.signin}
        element={
          <RouteManager
            title="Profile Sign In Landing"
            component={SignInContainer}
            eventName="profile_sign_in_landing"
          />
        }
      />
      <Route
        path={routes.secondScreen}
        element={
          <RouteManager
            title="Profile Sign In Landing"
            component={SignInContainer}
            eventName="profile_sign_in_landing"
          />
        }
      />
      <Route path={routes.mvpd} element={<RouteManager title="Sign In with TV Provider" component={MVPDContainer} />} />
      <Route path={routes.signout} element={<RouteManager title="Sign Out" component={SignOutContainer} />} />
      <Route
        path={routes.resetByEmail}
        element={
          <RouteManager
            title="Account Forgot Password Landing"
            component={ResetGetEmailContainer}
            eventName="forgot_password_landing"
          />
        }
      />
      <Route
        path={routes.resetPassword}
        element={<RouteManager title="Reset Password" component={ResetSignInContainer} />}
      />
      <Route
        path={routes.signupPlans}
        element={<RouteManager title="Select Plan Landing" component={SignUpPlansContainer} eventName="select_plan" />}
      />
      <Route
        path={routes.paymentPreSelectedPlan}
        element={
          <RouteManager isPrivate title="Checkout Landing" component={PaymentPage} eventName="checkout_landing" />
        }
      />
      <Route
        path={routes.payment}
        element={
          <RouteManager isPrivate title="Checkout Landing" component={PaymentPage} eventName="checkout_landing" />
        }
      />
      <Route
        path={routes.signupConfirmation}
        element={
          <RouteManager
            isPrivate
            title="Payment Success Landing"
            component={FoxOneConfirmation}
            eventName="payment_success"
          />
        }
      />
      <Route path={routes.siriusXMBango} element={<RouteManager isPrivate component={BangoFinal} />} />
      <Route path={routes.verizonBango} element={<RouteManager isPrivate component={BangoFinal} />} />
      <Route
        path={routes.signupCurrentSubscriber}
        element={<RouteManager isPrivate component={CurrentSubscriberContainer} />}
      />
      <Route
        path={routes.signupCurrentSubscriberMilitaryFirst}
        element={<RouteManager isPrivate component={CurrentSubscriberMilitaryFirst} />}
      />
      <Route
        path={routes.signupPreSelectedPlan}
        element={
          <RouteManager
            title="Profile Sign Up Landing"
            component={CreateContainer}
            eventName="profile_sign_up_landing"
          />
        }
      />
      <Route
        path={routes.signupCreateAccount}
        element={
          <RouteManager
            title="Profile Sign Up Landing"
            component={CreateContainer}
            eventName="profile_sign_up_landing"
          />
        }
      />
      <Route
        path={routes.supportedDevices}
        element={<RouteManager title="Supported devices" component={SupportedDevicesContainer} />}
      />
      <Route
        path={routes.giftingHome}
        element={<RouteManager title="Redeem Gift Landing" component={RedeemGiftHome} eventName="redeem_landing" />}
      />
      <Route
        path={routes.giftingReviewAndRedeem}
        element={<RouteManager title="Redeem your gift code" component={RedeemGiftCardContainer} />}
      />
      <Route
        path={routes.giftCardRedeemConfirmation}
        element={<RouteManager title="Giftcard Redeem Confirmation" component={Confirmation} />}
      />
      <Route
        path={routes.myAccount}
        element={
          <RouteManager
            isPrivate
            allowMvpd
            title="Settings Section Landing"
            eventName="settings"
            component={MyAccountContainer}
          />
        }
      />
      <Route path={routes.billingHistory} element={<RouteManager isPrivate component={BillingHistoryContainer} />} />
      <Route path={routes.shipping} element={<RouteManager isPrivate component={ShippingContainer} />} />
      <Route path={routes.editPayment} element={<RouteManager isPrivate component={EditPaymentContainer} />} />
      <Route
        path={routes.pauseSubscription}
        element={
          <RouteManager
            isPrivate
            title="Account Pause Landing"
            component={PauseSubscriptionContainer}
            eventName="pause_landing"
          />
        }
      />
      <Route path={routes.cancelPlan} element={<RouteManager isPrivate component={CancelPlanContainer} />} />
      <Route
        path={routes.cancelSurvey}
        element={
          <RouteManager
            isPrivate
            title="Account Cancel Survey Landing"
            eventName="cancel_survey_landing"
            component={CancelSurveyContainer}
          />
        }
      />
      <Route
        path={routes.cancelConfirmation}
        element={<RouteManager isPrivate component={CancelConfirmationContainer} />}
      />
      <Route
        path={routes.sheerIdVerification}
        element={<RouteManager isPrivate title="Sheer Id Verification" component={SheerIdVerificationPage} toCreate />}
      />
      <Route
        path={routes.vetAdvantageError}
        element={<RouteManager isPrivate title="WeSalute Error" component={VeteransAdvantageError} toCreate />}
      />
      {appEnv && appEnv !== 'production' && (
        <Route
          path={routes.featureFlags}
          element={<RouteManager title="Feature Flags" component={FeatureFlagsContainer} />}
        />
      )}
      <Route path="*" element={<RouteManager component={NotFoundContainer} />} />
    </Routes>
  </AppLayout>
);
